import * as React from 'react';

import type { CmlContent } from '@coursera-web/cml';
import { CML } from '@coursera-web/cml';

import { Button } from '@coursera/coursera-ui';

import { isVideoHighlightingEnabled } from 'bundles/video-highlighting/utils/highlightingFeatureToggles';

import _t from 'i18n!nls/course-sessions';

import 'css!./__styles__/BranchSwitchInfo';

type Props = {
  handleConfirm: () => void;
  changesDescription?: CmlContent;
};

// TODO: reconcile this component with SessionSwitchBranchChangeInfo
const BranchSwitchInfo = (props: Props) => {
  const { changesDescription, handleConfirm } = props;

  const message = isVideoHighlightingEnabled()
    ? _t(
        `Your instructor has made some changes to the course! Review the information below to learn
        more. You may need to complete additional assignments to pass the course in this version.
        If the instructor has removed or altered videos, then your highlights and notes
        will be preserved, but they may not link back to the original video.`
      )
    : _t(
        `Your instructor has made some changes to the course! Review the information below to learn
        more. You may need to complete additional assignments to pass the course in this version.`
      );

  return (
    <div className="rc-BranchSwitchInfo vertical-box flex-1">
      <h3 className="title">{_t('New in this version')}</h3>

      <div>
        <p className="body-1-text">{message}</p>
        <p className="body-2-text instructor-note">{_t('Note from your instructor:')}</p>
        <p className="body-1-text">
          <CML cml={changesDescription} />
        </p>
      </div>
      <div className="horizontal-box align-items-right wrap">
        <Button rootClassName="confirm-button" type="primary" onClick={handleConfirm}>
          {_t('Confirm')}
        </Button>
      </div>
    </div>
  );
};

export default BranchSwitchInfo;
